module.exports = __webpack_public_path__ + "img/Ghavamin.6d30bb85.svg";